/**
 * To map properties of each possible filter
 * @description: Below constant maps each filter with its properties. We can directly access all possible filter and its
 * properties from a central place.
 */

interface FilterConfig {
  label: string;
  apiKey: string;
  urlKey: string;
  defaultValue: string | number | boolean;
  valueLabel: string;
  valueKey: string;
  order: number;
}
interface FiltersMapping {
  [key: string]: FilterConfig;
}

interface FormDataType {
  [key: string]: "string" | "number" | "boolean";
}

export const FilterMapping: FiltersMapping = {
  by_category: {
    label: "Category",
    apiKey: "category",
    urlKey: "category",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 1,
  },
  by_speaker: {
    label: "Speaker",
    apiKey: "speaker",
    urlKey: "speaker",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 6,
  },
  by_firm: {
    label: "Firm",
    apiKey: "firm",
    urlKey: "firm",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 7,
  },
  by_subject: {
    label: "Subjects",
    apiKey: "subject",
    urlKey: "subject",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 2,
  },
  by_level: {
    label: "Level",
    apiKey: "level",
    urlKey: "level",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 3,
  },
  by_focusarea: {
    label: "Focus Area",
    apiKey: "focusarea",
    urlKey: "focusarea",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 4,
  },
  by_date: {
    label: "Date",
    apiKey: "date",
    urlKey: "date",
    defaultValue: "",
    valueLabel: "name",
    valueKey: "id",
    order: 5,
  },
};

export const FormDataKeyType: FormDataType = {
  category: "string",
  subject: "string",
  level: "string",
  focusarea: "string",
  data: "string",
};
